// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__4opr3","col":"styles_col__36aPr","fulfillmentStatus":"styles_fulfillmentStatus__1JV2y","emailCol":"styles_emailCol__3HDLU"};